//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import Context from "context/context";
import Loader from "components/Loader/Loader";
import Logo from "assets/img/logo.png";
import { styles } from "./styles";

// material-ui
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
// material-ui icons
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

export default function LoyaltyInactive() {
  const classes = styles();
  return (
    <div
     className={classes.mainDiv}
    >
      <img src={Logo} height="300" alt="logo" />
      <div className={classes.divText}>
        Loyalty program is not yet activated.
      </div>
    </div>
  );
}
